/* eslint-disable no-undef */
export var WAIMAI_API_BASE_URL = ''
export var DS_API_BASE_URL = ''
export var MP_API_BASE_URL = ''
export var MDC_API_BASE_URL = ''
export var RMS_API_BASE_URL = ''
export var WB_API_BASE_URL = ''

console.log('env', process.env)
switch (process.env.VUE_APP_CURENV) {
    case 'development':
        WAIMAI_API_BASE_URL = '/WAIMAI_API_BASE_URL'
        DS_API_BASE_URL = '/DS_API_BASE_URL'
        MP_API_BASE_URL = '/MP_API_BASE_URL'
        MDC_API_BASE_URL = '/MDC_API_BASE_URL'
        RMS_API_BASE_URL = 'https://api-rms.xibeidev.com'
        break
    case 'test':
        WAIMAI_API_BASE_URL = 'https://juzq.xibeidev.com' //开发环境url
        DS_API_BASE_URL = 'https://wb.xibeidev.com'
        MP_API_BASE_URL = 'https://schedule.xibeidev.com'
        MDC_API_BASE_URL = 'https://mdc.xibeidev.com/index.php'
        RMS_API_BASE_URL = 'https://api-rms.xibeidev.com'
        break
    case 'production':
        WAIMAI_API_BASE_URL = 'https://wm.xibei.com.cn/' //生产环境url
        DS_API_BASE_URL = 'https://gw.xibei.com.cn/workbench'
        MP_API_BASE_URL = 'https://gw.xibei.com.cn/scheduling'
        MDC_API_BASE_URL = 'https://mdc.xibei.com.cn'
        RMS_API_BASE_URL = 'https://gw.xibei.com.cn/rmsapi'
        break
}
